export function hasCommonValue<T>(array1: T[], array2: T[]): boolean {
	return array1.some((value) => array2.includes(value));
}
